/**
 * Where to go after signing in. A deep link opened while signed out (e.g. a
 * scanned `/claim?code=…` QR) is remembered here and restored after login,
 * including SSO, whose redirect round-trip keeps the same tab's sessionStorage.
 * Reading doesn't clear it (login may navigate from more than one place);
 * `RequireAuth` clears it once a signed-in page renders.
 */

const KEY = 'akarya.returnTo';

export function rememberReturnTo(path: string): void {
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    // Storage blocked (private mode) — the user just lands on the default page.
  }
}

/** The remembered in-app path, or `fallback`. */
export function readReturnTo(fallback: string): string {
  try {
    const path = sessionStorage.getItem(KEY);
    // Only same-app paths — never an absolute or protocol-relative URL.
    if (path && path.startsWith('/') && !path.startsWith('//')) return path;
  } catch {
    // ignore
  }
  return fallback;
}

export function clearReturnTo(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
